import { Injectable } from '@angular/core';
import { HttpService } from '../app/utility/http-service';

export interface SecurityExport {
  recordId?: string;
  clientId?: string;

  enabled: boolean;
  autoRun: boolean;
  name: string;

  view: string;
  exportFileName: string;
  dateFormat?: string;

  dataSourceId: string;

  recipients?: string[];

  schedule?: string;

  editing?: boolean;
  isNew?: boolean;
}


export interface SecurityExportRequest {
  clientId: string;
  exportId: string;
}


@Injectable({
  providedIn: 'root'
})
export class SecurityExportService {
  private readonly basePath = 'ClientSettings';

  constructor(private http: HttpService) { }

  getSecurityExports(clientId: string, onSuccess: (exports: SecurityExport[]) => void): void {
    const uri = `${this.basePath}/GetSecurityExports?clientId=${clientId}`;
    this.http.get<SecurityExport[]>(uri, onSuccess);
  }

  getSecurityExport(clientId: string, exportId: string, onSuccess: (exportItem: SecurityExport) => void): void {
    const uri = `${this.basePath}/GetSecurityExport?clientId=${clientId}&exportId=${exportId}`;
    this.http.get<SecurityExport>(uri, onSuccess);
  }

  addSecurityExport(clientId: string, exportItem: SecurityExport, onSuccess: (savedExport: SecurityExport) => void): void {
    const uri = `${this.basePath}/AddSecurityExport?clientId=${clientId}`;
    this.http.postReturn<SecurityExport>(uri, onSuccess, undefined, exportItem);
  }


  updateSecurityExport(clientId: string, exportItem: SecurityExport, onSuccess: () => void): void {
    const uri = `${this.basePath}/UpdateSecurityExport?clientId=${clientId}`;
    this.http.post(uri, onSuccess, undefined, exportItem);
  }

  deleteSecurityExport(request: SecurityExportRequest, onSuccess: () => void): void {
    const uri = `${this.basePath}/DeleteSecurityExport?clientId=${request.clientId}&exportId=${request.exportId}`;
    this.http.post(uri, onSuccess);
  }

  runSecurityExportNow(request: SecurityExportRequest, onSuccess: () => void): void {
    const uri = `${this.basePath}/RunSecurityExportNow?clientId=${request.clientId}&exportId=${request.exportId}`;
    this.http.post(uri, onSuccess, undefined, request);
  }

}
